<!-- <h5><span>Musaffa ISRI Score</span> <span
        ngbTooltip="IRI reports provided by Musaffa are based on our proprietary scoring system. These reports are intended for informational purposes only and do not constitute legal, investm"
        placement="top" [tooltipClass]="'tooltip_white_bg'" style="display: inline-block; cursor: pointer;">
        <img src="../../../../assets/icons/IconInfo.svg" alt="Info" />
    </span>
</h5>
<h4>1.5/<span>5</span> <small>Weak</small></h4>
<h6>Last Update : <span>April 26, 2025</span></h6> -->


<h5>
    <span>Musaffa ISRI Score</span>
    <span
        ngbTooltip="Assigned by Musaffa’s research team, this score reflects the company’s alignment with Islamic ethical and moral standards. It is based on the Islamic Socially Responsible Investing (IRI) framework — a proprietary scoring system developed by Musaffa."
        placement="top" [tooltipClass]="'tooltip_white_bg'" style="display: inline-block; cursor: pointer;">
        <img src="../../../../assets/icons/IconInfo.svg" alt="Info" />
    </span>
</h5>

<div class="rating_row_top" style="position: relative;">
    <h4>
        {{ musaffaData?.iri_score != null ? musaffaData.iri_score : '-' }}/<span>5</span>
        <small [ngClass]="getScoreClass(musaffaData?.score_classification)">{{ musaffaData?.score_classification
            }}</small>
    </h4>
    <!-- <button class="btn__rate" (click)="toggleVisibility()">Share</button> -->

   <div class="position-absolute top-50 end-0 translate-middle-y share_wrap">
  <app-share-links-popup [isIRIReport]="isIRIReport" *ngIf="!isSample"></app-share-links-popup>
</div>

</div>



<h6 *ngIf="musaffaData?.iri_score != null">
    Last Update :
    <span>{{ musaffaData.last_update_time | date: 'MMMM d, y' }}</span>
</h6>
